import { IoArrowBackCircleOutline } from 'react-icons/io5';
import './PrivacyPolicy.scss';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className='container'>
        <h1 className='heading'>
          <div onClick={() => navigate('/')}>
            <IoArrowBackCircleOutline className='back-icon' />
          </div>

          <b>PRIVACY POLICY :</b>
        </h1>
        <p className='p'>
          <li>
            The Website Owner, including subsidiaries and affiliates
            snapcityinpune@gmail.com provides the information contained on the
            website or any of the pages comprising the website
            www.snapcityinpune.com to visitors (.visitors.) (cumulatively
            referred to as .you. or .your. hereinafter) subject to the terms and
            conditions city out in these website terms and conditions, the
            privacy policy and any other relevant terms and conditions, policies
            and notices which may be applicable to a specific section or module
            of the website. Welcome to our website. If you continue to browse
            and use this website you are agreeing to comply with and be bound by
            the following terms and conditions of use, which together with our
            privacy policy govern Snapcity in Pune with you in relation to this
            website. The term Snapcity in Pune refers to the owner of the
            website whose registered office is Snapcity in Pune Talegaon Dabhade
            old Mumbai-Pune higway behind Indian oil Petrol Pump 410506.The term
            'you' refers to the user or viewer of our website.
          </li>
        </p>

        <h3>
          The use of this website is subject to the following terms of use
        </h3>
        <p>
          <li>
            {' '}
            The content of the pages of this website is for your general
            information and use only. It is subject to change without notice.
          </li>
          <li>
            Neither we nor any third parties provide any warranty or guarantee
            as to the accuracy, timeliness, performance, completeness or
            suitability of the information and materials found or offered on
            this website for any particular purpose. You acknowledge that such
            information and materials may contain inaccuracies or errors and we
            expressly exclude liability for any such inaccuracies or errors to
            the fullest extent permitted by law.
          </li>
          <li>
            Your use of any information or materials on this website is entirely
            at your own risk, for which we shall not be liable. It shall be your
            own responsibility to ensure that any products, services or
            information available through this website meet your specific
            requirements.
          </li>
          <li>
            {' '}
            This website contains material which is owned by or licensed to us.
            This material includes, but is not limited to, the design, layout,
            look, appearance and graphics. Reproduction is prohibited other than
            in accordance with the copyright notice, which forms part of these
            terms and conditions.
          </li>
          <li>
            {' '}
            All trademarks reproduced in this website which are not the property
            of, or licensed to, the operator are acknowledged on the website.
          </li>
          <li>
            {' '}
            Unauthorized use of this website may give rise to a claim for
            damages and/or be a criminal offence.
          </li>
          <li>
            From time to time this website may also include links to other
            websites. These links are provided for your convenience to provide
            further information. They do not signify that we endorse the
            website(s). We have no responsibility for the content of the linked
            website(s).
          </li>
          <li>
            {' '}
            You may not create a link to this website from another website or
            document without “Snapcity in Pune” prior written consent.
          </li>
          <li>
            {' '}
            Your use of this website and any dispute arising out of such use of
            the website is subject to the laws of India or other regulatory
            authority.{' '}
          </li>
          <li>
            {' '}
            "We as a merchant shall be under no liability whatsoever in respect
            of any loss or damage arising directly or indirectly out of the
            decline of authorization for any Transaction, on Account of the
            Cardholder having exceeded the preset limit mutually agreed by us
            with our acquiring bank from time to time".
          </li>
        </p>
        <br />

        <h3>Privacy Policy</h3>
        <p>
          <li>
            A privacy policy states how you will respect the privacy of your
            website users. It says what information you will gather, how you
            will use it and how you will keep it secure.
          </li>
          <li>
            {' '}
            A privacy policy is a legal document that discloses some or all of
            the ways a party gathers, uses, discloses and manages a customer's
            data. The exact contents of a privacy policy will depend upon the
            applicable law and may need to address the requirements of multiple
            countries or jurisdictions. While there is no universal guidance for
            the content of specific privacy policies, a number of organizations
            provide example forms.
          </li>
        </p>
        <br />

        <h3>Website privacy</h3>
        <p>
          <li>
            {' '}
            This privacy policy sets out how Snapcity uses and protects any
            information that you give Snap city when you use this website.
          </li>
          <li>
            {' '}
            Snapcity is committed to ensuring that your privacy is protected.
            Should we ask you to provide certain information by which you can be
            identified when using this website, and then you can be assured that
            it will only be used in accordance with this privacy statement.
          </li>
          <li>
            {' '}
            Snapcity may change this policy from time to time by updating this
            page. You should check this page from time to time to ensure that
            you are happy with any changes. This policy is effective from 1st
            January 2022.
          </li>
        </p>
        <br />

        <h3>What we collect</h3>
        <h3>We may collect the following information</h3>
        <p>
          <li> Name </li>
          <li>
            Contact information including email address and Whatsapp Number.
          </li>
          <li>Other information relevant to customer surveys and/or offers.</li>
        </p>
        <br />

        <h3>What we do with the information we gather</h3>
        <h3>
          We require this information to understand your needs and provide you
          with a better service, and in particular for the following reasons
        </h3>
        <p>
          <li>Internal record keeping.</li>
          <li>
            We may use the information to improve our products and services.
          </li>
          <li>
            {' '}
            We may periodically send promotional emails/Whatsapp Messages about
            new products, special offers or other information which we think you
            may find interesting using the email address which you have
            provided.
          </li>
          <li>
            {' '}
            From time to time, we may also use your information to contact you
            for market research purposes. We may contact you by email or
            Whatsapp Messages l. We may use the information to customize the
            website according to your interests.
          </li>
        </p>
        <br />

        <h3>Security</h3>
        <p>
          <li>
            {' '}
            We are committed to ensuring that your information is secure. In
            order to prevent unauthorized access or disclosure we have put in
            place suitable physical, electronic and managerial procedures to
            safeguard and secure the information we collect online.
          </li>
        </p>
        <br />

        <h3>Privacy Policy</h3>
        <p>
          <li>
            {' '}
            A privacy policy states how you will respect the privacy of your
            website users. It says what information you will gather, how you
            will use it and how you will keep it secure.
          </li>
          <li>
            {' '}
            A privacy policy is a legal document that discloses some or all of
            the ways a party gathers, uses, discloses and manages a customer's
            data. The exact contents of a privacy policy will depend upon the
            applicable law and may need to address the requirements of multiple
            countries or jurisdictions. While there is no universal guidance for
            the content of specific privacy policies, a number of organizations
            provide example forms.
            <br /> In Case of cancellation before one month of schedule date,
            the guest shall be refunded within one month from date of
            cancellation. The booking amount after deducting therefrom such
            expenses as incurred by the management for the booking event.
            Government charges or payment gateway charges (e-Payment charges)
            are not refundable on cancellation of bookings.
          </li>
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
